var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"project-box"},[_c(_vm.projectStep,{tag:"component",on:{"cancel":_vm.cancel,"saveProjectName":_vm.saveProjectName,"saveProjectProfile":_vm.saveProjectProfile,"saveProjectDescription":_vm.saveProjectDescription}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }